<template>
  <div
    class="input"
    v-bind:class="{['input-'+width]: width, ['textalign-'+textalign]: textalign}"
    v-if="type=='textarea'"
  >
    <label class v-if="label">{{label}}</label>
    <textarea-autosize
      :placeholder="placeholder"
      v-model="val"
      :min-height="30"
      :max-height="100"
      class="to-validate"
    ></textarea-autosize>
  </div>
  <div
    class="input tags-input"
    v-bind:class="{['input-'+width]: width, ['textalign-'+textalign]: textalign}"
    v-else-if="type=='tags'"
    @keyup.delete="deleteTag"
    @keyup.space="addTag"
    @keyup.enter="addTag"
    @keydown.tab="addTag"
  >
    <label class v-if="label">{{label}}</label>
    <div class="tags-wrap">
      <div class="tags to-validate">
        <span
          class="tag tag-active"
          v-for="(tag, index) in tags"
          v-bind:class="{'to-delete': tag.deleting}"
        >
          {{tag.value}}
          <svgicon name="cross" @click.native="deleteTagInstantly(index)"/>
        </span>
        <span class="tag tag-input">
          <input type="text" class="new-tag-input" v-bind:placeholder="$t('form.receivers.placeholder')" v-model="tagToAdd" @blur="addTag">
        </span>
      </div>
    </div>
  </div>
  <div class="input image-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='image'">
    <input
      id="image-file"
      ref="file"
      type="file"
      name="image-file"
      accept="image/*"
      class="imageinput to-validate"
      v-on:change="upload"
    >
    <label for="image-file">
      <svgicon name="image" width="3rem" height="3rem"></svgicon>
    </label>
  </div>
  <div class="input file-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='file'">
    <input type="file" name="file" id="file" class="inputfile">
    <label for="file">Kies een bestand</label>
  </div>
  <div
    class="input avatar-input"
    v-bind:class="{['input-'+width]: width}"
    v-else-if="type=='avatar'"
  >
    <input id="avatar-file" type="file" name="image-file" class="image-input">
    <label for="avatar-file">
      <Avatar size="xxxl">
        <slot></slot>
      </Avatar>
      <div class="edit-avatar">
        <div class="flex-content">
          <div class="width-100 relative text-center">
            <svgicon name="edit"></svgicon>
          </div>
        </div>
      </div>
    </label>
  </div>
  <div
    class="input avatar-input"
    v-bind:class="{['input-'+width]: width}"
    v-else-if="type=='avatar-modal'"
  >
    <div class="avatar-wrap">
      <Avatar size="xxxl">
        <slot></slot>
      </Avatar>
      <div class="edit-avatar">
        <div class="flex-content">
          <div class="width-100 relative text-center">
            <svgicon name="edit"></svgicon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="input toggle-input"
    v-bind:class="{['input-'+width]: width}"
    v-else-if="type=='toggle'"
  >
    <label class="switch">
      <input type="checkbox" checked>
      <span class="slider round"></span>
    </label>
  </div>
  <div
    class="input checkbox-input"
    v-bind:class="{['input-'+width]: width}"
    v-else-if="type=='checkbox'"
  >
    <label class="checkbox" v-bind:class="{'float-left': label}">
      <input type="checkbox">
      <span class="checkmark"></span>
    </label>
    <div class="checkbox-label float-left">{{label}}</div>
  </div>
  <div class="input radio-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='radio'">
    <label class="radio" v-bind:class="{'float-left': label}">
      <input type="radio">
      <span class="checkmark"></span>
    </label>
    <div class="radio-label float-left">{{label}}</div>
  </div>
  <div class="input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='select'">
    <label class v-if="label">{{label}}</label>
    <select>
      <slot></slot>
    </select>
  </div>
  <div
    class="input"
    v-bind:class="{['input-'+width]: width, ['textalign-'+textalign]: textalign}"
    v-else
  >
    <label class v-if="label">{{label}}</label>
    <input
      :id="id"
      :type="type"
      :placeholder="placeholder"
      v-model="val"
      :disabled="disabled"
      class="to-validate"
    >
  </div>
</template>
<script>
export default {
  name: "Input",
  components: {},
  props: {
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    state: {
      type: String
    },
    value: {},
    width: {
      type: String,
      default: "expand"
    },
    id: {
      type: String
    },
    type: {
      type: String,
      default: "text"
    },
    textalign: {
      type: String,
      default: "left"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVal: this.value,
      tagToAdd: "",
      tags: null
    };
  },
  watch: {
    tags: function(val, oldVal) {
      if (oldVal !== null) {
        this.$emit(
          "input",
          val.map(tag => {
            return tag.value;
          })
        );
      }
    },
    inputVal(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    /*tags: {
                get: function () {
                    if(typeof this.value !== "undefined"){
                        return this.value.map(value => {
                            return {value: value, deleting: false}
                        })
                    }
                    else{
                        return []
                    }
                },
                // setter
                set: function (newValue) {
                    this.$emit('input', newValue.map(tag=>{
                        return tag.value;
                    }));
                }
            },*/
    val: {
      // getter
      get: function() {
        return this.value;
      },
      // setter
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  mounted() {
    if (this.type == "tags") {
      this.tags = this.value.map(val => {
        return { value: val, deleting: false };
      });
    }
  },
  methods: {
    upload() {
      this.$emit("input", this.$refs.file);
    },
    addTag: function() {
      if (this.tagToAdd.replace(/\s/g, "").length) {
        if (this.tags.length > 0) {
          this.tags[this.tags.length - 1].deleting = false;
        }
        var tag = this.tagToAdd.replace(/\s/g, "");
        this.tags.push({ value: tag, deleting: false });
        this.tagToAdd = "";
        this.$forceUpdate();
      }
    },
    deleteTag: function() {
      if (this.tagToAdd < 1 && this.tags.length > 0) {
        //check if input is empty
        if (this.tags[this.tags.length - 1].deleting == false) {
          this.tags[this.tags.length - 1].deleting = true;
        } else {
          this.tags.pop();
        }
      }
    },
    deleteTagInstantly: function(index) {
      this.tags.splice(index, 1);
      this.$forceUpdate();
    }
  }
};
</script>
<style src="./Input.scss" scoped lang="scss"></style>

